export default {"src":"/_next/static/media/success_payment.b4bb7e97.svg","height":335,"width":320,"blurWidth":0,"blurHeight":0};